var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Slideshow Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2083 20.5417C26.4028 20.4167 26.5 20.2396 26.5 20.0104C26.5 19.7812 26.4028 19.5972 26.2083 19.4583L17.0833 13.5833C16.8611 13.4444 16.6458 13.4375 16.4375 13.5625C16.2292 13.6875 16.125 13.875 16.125 14.125V25.875C16.125 26.125 16.2292 26.3125 16.4375 26.4375C16.6458 26.5625 16.8611 26.5556 17.0833 26.4167L26.2083 20.5417ZM7.5 35C6.83333 35 6.25 34.75 5.75 34.25C5.25 33.75 5 33.1667 5 32.5V7.5C5 6.83333 5.25 6.25 5.75 5.75C6.25 5.25 6.83333 5 7.5 5H32.5C33.1667 5 33.75 5.25 34.25 5.75C34.75 6.25 35 6.83333 35 7.5V32.5C35 33.1667 34.75 33.75 34.25 34.25C33.75 34.75 33.1667 35 32.5 35H7.5ZM7.5 32.5H32.5V7.5H7.5V32.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSlide);
export default __webpack_public_path__ + "static/media/White-Slide.7068566ada57ad59d7d926826ca56e69.svg";
export { ForwardRef as ReactComponent };